import { ItemType } from '@vista-digital/ocapi-types/v1';
export const mapOrderItemLineToOrderItemRequest = (item) => {
    const { id, itemId, type, discountId, rewardId, parentSalesItemId } = item;
    const orderItemRequest = {
        id,
        itemId,
        type,
        discountId,
        rewardId,
        parentSalesItemId
    };
    switch (item.type) {
        case ItemType.Normal:
            return Object.assign(Object.assign({}, orderItemRequest), { type: ItemType.Normal, modifierGroups: item.modifierGroups.map(mapOrderItemModifierGroupToOrderItemModifierGroupRequest) });
        default:
            return orderItemRequest;
    }
};
const mapOrderItemModifierGroupToOrderItemModifierGroupRequest = (group) => {
    return {
        itemModifierGroupId: group.itemModifierGroupId,
        modifiers: group.modifiers.map(modifier => ({
            itemId: modifier.itemId
        }))
    };
};
